import { combineReducers } from "redux";
import { faqsectionsReducer } from "./faqsections";
import { faqentriesReducer } from "./faqentries";


export default combineReducers( {
  sections: faqsectionsReducer,
  entries: faqentriesReducer
});